import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

export const Wrapper = styled.div``;

export const Label = styled.p`
  color: ${COLORS.BLACK};
  font-family: ${FONTS.OPEN_SANS};
  margin-bottom: 10px;
  font-size: 12px;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const ActionProfile = styled.div`
  display: flex;
  margin-bottom: 26px;
  label:last-child {
    margin-left: 22px;
  }
`;

export const TicketWrapper = styled.div``;

export const BillWrapper = styled.div``;

export const CentralHelp = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};
  margin: -20px 0 30px;
  font-weight: 700;
`;

export const LinkHelp = styled.a`
  color: ${(props: Props) => props.color};
  font-size: 12px;
  text-decoration: underline;
`;

export const FieldWrapper = styled.div``;

export const IconInfo = styled.span`
  margin: 0 auto 0 4px;
  cursor: pointer;
`;

export const ModalContent = styled.p`
  width: 250px;
  margin: 50px 30px 30px;
  font-family: ${FONTS.OPEN_SANS};
`;